import * as React from "react";

import Heading from "../atoms/heading";
import List from "../atoms/list";
import Section from "../atoms/section";
import Spinner from "../atoms/spinner";
import { Label, Patience } from "../business/interfaces";
import SavedForm, { Props as SavedFormProps } from "./savedForm";

export type Props = Label & {
  savedForms?: SavedFormProps[];
};

const SavedForms = React.memo<Patience & Props>(
  ({ label, savedForms, patience }) => (
    <Section subType="forms-saved">
      <Heading level="h2" label={label} />
      <List subType="forms-saved">
        {savedForms === undefined ? (
          <Spinner label={patience} />
        ) : (
          savedForms.map((form) => <SavedForm key={form.href} {...form} />)
        )}
      </List>
    </Section>
  )
);

export default SavedForms;
